export default "__VITE_ASSET__COcJgeBQ__"